module.exports = {"attributes":{"width":"3","height":"8","viewBox":"0 0 3 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.09143 5.3935C0.838355 5.3935 0.625185 5.2044 0.595001 4.95313L0.067236 0.559634C0.0314815 0.261988 0.263881 0 0.563667 0H1.9479C2.24357 0 2.47467 0.255182 2.44545 0.549408L2.00917 4.94291C1.98377 5.19866 1.76862 5.3935 1.51161 5.3935H1.09143ZM1.30616 8C1.05489 8 0.846086 7.92214 0.679751 7.76642C0.516955 7.60717 0.435557 7.40544 0.435557 7.16125C0.435557 6.91351 0.516955 6.71179 0.679751 6.55607C0.846086 6.39681 1.05489 6.31719 1.30616 6.31719C1.56097 6.31719 1.76978 6.39681 1.93257 6.55607C2.09537 6.71179 2.17676 6.91351 2.17676 7.16125C2.17676 7.40544 2.09537 7.60717 1.93257 7.76642C1.76978 7.92214 1.56097 8 1.30616 8Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
